// @ts-nocheck
import { Navigate } from "react-router-dom"
import { AdminTopicsClient } from "@/components/admin/topics/AdminTopicsClient"
import { useAuth } from "@/components/layout/AuthProvider"

export default function AdminTopicsPage() {
  const { user } = useAuth()
  if (!user || user.role !== "admin") return <Navigate to="/feed" replace />
  return <div className="container-app py-4"><AdminTopicsClient /></div>
}